import { datadogRum, RumInitConfiguration } from '@datadog/browser-rum';

const sharedConfig: Partial<RumInitConfiguration> = {
  version: process.env.APP_REVISION,
  sessionSampleRate: 10,
  sessionReplaySampleRate: 0,
  trackUserInteractions: true,
  defaultPrivacyLevel: 'allow',
};

const developmentConfig: RumInitConfiguration = {
  applicationId: 'f2ae80ea-ea07-476c-8c0d-9f5c7a64ef61',
  clientToken: 'pub38e4a57cf2e9725f7de0db5d9c725b21',
  site: 'datadoghq.eu',
  service: 'merchant-admin',
  env: 'development',
  ...sharedConfig,
};

const productionConfig: RumInitConfiguration = {
  applicationId: 'f0102387-cf9a-4fc9-9840-0509bc872f80',
  clientToken: 'pubdcf33beb3ca87b457a466b165e6937a6',
  site: 'datadoghq.eu',
  service: 'merchant-admin',
  env: 'production',
  ...sharedConfig,
};

const initDatadogRum = () => {
  if (process.env.APP_ENV === 'development' && process.env.NODE_ENV === 'development') {
    datadogRum.init(developmentConfig);
    datadogRum.startSessionReplayRecording();
  }
  if (process.env.APP_ENV === 'production' && process.env.NODE_ENV === 'production') {
    datadogRum.init(productionConfig);
    datadogRum.startSessionReplayRecording();
  }
};

export default initDatadogRum;
